import { useState } from "react";
import { X } from "lucide-react";

const norm = (t) => t.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

export const addKeywords = (list, raw) => {
  const out = [...list];
  raw.split(",").map((k) => k.replace(/\s+/g, " ").trim()).filter(Boolean).forEach((k) => {
    if (!out.some((x) => norm(x) === norm(k))) out.push(k.slice(0, 120));
  });
  return out;
};

export const KeywordTagsInput = ({ value, onChange, draft, onDraftChange }) => {
  const [focus, setFocus] = useState(false);
  const commit = () => { if (draft.trim()) { onChange(addKeywords(value, draft)); onDraftChange(""); } };

  return (
    <div
      data-testid="auto-reply-keywords-box"
      className={`flex flex-wrap items-center gap-1.5 min-h-[44px] rounded-md border bg-white px-2 py-1.5 transition-colors ${focus ? "border-[#1A1A1A]" : "border-input"}`}
    >
      {value.map((k) => (
        <span key={k} data-testid={`auto-reply-keyword-tag-${k}`} className="inline-flex items-center gap-1 rounded-full bg-[#F1EBE1] text-[#1A1A1A] text-xs font-medium pl-2.5 pr-1 py-1">
          {k}
          <button type="button" data-testid={`auto-reply-keyword-remove-${k}`} onClick={() => onChange(value.filter((x) => x !== k))}
            className="h-4 w-4 rounded-full flex items-center justify-center hover:bg-[#E0D3BC]" title="Quitar">
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      <input
        data-testid="auto-reply-keyword-input"
        value={draft}
        maxLength={120}
        onFocus={() => setFocus(true)}
        onBlur={() => { setFocus(false); commit(); }}
        onChange={(e) => (e.target.value.includes(",") ? (onChange(addKeywords(value, e.target.value)), onDraftChange("")) : onDraftChange(e.target.value))}
        onKeyDown={(e) => {
          if (e.key === "Enter") { e.preventDefault(); commit(); }
          if (e.key === "Backspace" && !draft && value.length) onChange(value.slice(0, -1));
        }}
        placeholder={value.length ? "Añadir otra…" : "Ej.: precio, coste, cuánto cuesta"}
        className="flex-1 min-w-[140px] bg-transparent text-sm outline-none px-1 py-1"
      />
    </div>
  );
};
